var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('h1',[_vm._v(_vm._s(_vm.$t('home')))]),_c('SurveysList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }